export default __webpack_public_path__ + "static/media/Thermocycler.87c89d1e.svg";